export const fileToBase64 = (data, fileType) => {
  return new Promise((resolve, reject) => {
    if (!data) return;
    const reader = new FileReader();

    // Handle different file types based on their MIME type
    if (data.type.match('text')) {
      reader.readAsText(data);
    } else if (data.type.match('image')) {
      reader.readAsDataURL(data);
    } else if (data.type.match('pdf')) {
      reader.readAsDataURL(data);
    } else if (data.type.match('sheet')) {
      // Handle Excel or other spreadsheet types
      // You can implement this logic based on your requirements
      reject(`Unsupported file type: ${data.type}`);
    } else {
      // For unknown file types, reject with an appropriate message
      reject(`Unsupported file type: ${data.type}`);
    }

    reader.onload = () => {
      const base64Data = reader.result;
      resolve(base64Data);
    };

    reader.onerror = (error) => {
      reject(`Error converting file to ${fileType}: ${error}`);
    };
  });
};

export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    if (!blob) return;
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(blob);
  });
};


export const convertBase64ToFile = (base64, filename, givenMimeType) => {
  // Check if the Base64 string has a prefix and remove it
  console.log(base64)
  const base64Pattern = /^data:(.*?);base64,/;
  const base64WithoutPrefix = base64.replace(base64Pattern, "");

  try {
    // Decode Base64
    const bstr = atob(base64WithoutPrefix); // This may throw an error if invalid
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    // Extract MIME type if available
    const mimeMatch = base64.match(base64Pattern);
    const mimeType = mimeMatch ? mimeMatch[1] : "";

    // Return the File
    return new File([u8arr], filename, { type: givenMimeType ? givenMimeType : mimeType });
  } catch (error) {
    throw new Error("Invalid Base64 string. Please provide a valid input.");
  }
};

export const downloadFile = (file) => {
  const blobURL = URL.createObjectURL(file); // Create a blob URL
  const a = document.createElement("a"); // Create a temporary anchor element
  a.href = blobURL;
  a.download = file.name; // Set the file name
  document.body.appendChild(a); // Append the anchor to the DOM
  a.click(); // Programmatically trigger the download
  document.body.removeChild(a); // Remove the anchor after download
  URL.revokeObjectURL(blobURL); // Revoke the blob URL
};